<template>
<div class="dialogEnv">
  <el-form ref="form" label-width="45%" class="formMsg" :disabled="disabled" v-if="parType === '1'" v-loading="loading">
    <road-form1 :formItem="road1"></road-form1>
  </el-form>

  <el-form ref="form" label-width="45%" class="formMsg" :disabled="disabled" v-if="parType === '2'">
    <road-form2 :formItem="road2"></road-form2>
  </el-form>
</div>
</template>

<script>
import bus from './bus'
import qs from 'qs'
import arrayData from '../assets/javascript/dataProcess'
import roadForm1 from '../assets/components/form'
import roadForm2 from '../assets/components/form'

export default {
  name: "dialogEnv",
  components:{
    roadForm1,
    roadForm2
  },
  data() {
    return {
      /*加载动画*/
      loading: false,
      /*是否可编辑*/
      disabled: true,
      /*参与方编号*/
      parType: '1',
      /*道路信息数据*/
      roadData: [],
      road1: [],
      road2: []
    }
  },
  methods: {
    /*数据渲染*/
    dataRender() {
      let data = this.roadData;
      for (let i = 0; i < this.road1.length; i++) {
        for (let key of Object.keys(data[0])) {
          if (key === this.road1[i].name) {
            this.road1[i].value = data[0][key];
          }
        }
      }
      if (data.length > 1) {
        for (let i = 0; i < this.road2.length; i++) {
          for (let key of Object.keys(data[1])) {
            if (key === this.road2[i].name) {
              this.road2[i].value = data[1][key];
            }
          }
        }
      }
    },
    /*数据修改函数*/
    changeData() {
      let formData = {};
      if (this.parType === "1") {
        if (this.road1[0].value === '' || this.road1[1].value === '' || this.road1[2].value === '') {
          for (let i = 0; i < 3; i++) {
            if (this.road1[i].value === "") {
              this.$set(this.road1[i], "warning", 1);
              this.$set(this.road1[i], "warningMsg", "必填信息不得为空");
            }
          }
        } else {
          for (let i = 0; i < this.road1.length; i++) {
            formData[this.road1[i].name] = this.road1[i].value;
          }
          formData.id = this.roadData[0].id;
          formData.totalId = this.roadData[0].totalId;
          this.loading = true;
          this.$http.put(
              '/road/road',
              formData, {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
            )
            .then((res) => {
              this.$message({
                message: "道路信息一修改成功",
                type: 'success',
                center: true,
                duration: 1000
              });
              this.number = false;
              this.$nextTick(
                this.loading = false,
              );
            })
            .catch((err) => {
              console.log(err);
              this.$nextTick(
                this.loading = false,
              );
            });
        }
      } else {
        if (this.road2[0].value === '' || this.road2[1].value === '' || this.road2[2].value === '') {
          for (let i = 0; i < 3; i++) {
            if (this.road2[i].value === "") {
              this.$set(this.road2[i], "warning", 1);
              this.$set(this.road2[i], "warningMsg", "必填信息不得为空");
            }
          }

        } else {
          for (let i = 0; i < this.road2.length; i++) {
            formData[this.road2[i].name] = this.road2[i].value;
          }
          formData.id = this.roadData[1].id;
          formData.totalId = this.roadData[1].totalId;

          this.$http.put(
              '/road/road',
              formData, {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
            )
            .then((res) => {
              this.$message({
                message: "道路信息二修改成功",
                type: 'success',
                center: true,
                duration: 1000
              });
              this.next = false;
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    }
  },
  created() {
    this.road1 = arrayData.data3.road;
    this.road2 = arrayData.data3.road_copy;
    /*接收参与方编号*/
    bus.$on("parType", msg => {
      this.parType = msg;
    });
    /*可以编辑*/
    bus.$on("change", () => {
      this.disabled = false;
    });
    /*不可以修改*/
    bus.$on("disable", () => {
      this.disabled = true;
    });
    /*接收数据*/
    bus.$on("road", msg => {
      this.roadData = msg;
      this.dataRender();
    });
    /*接收案例编号*/
    bus.$on("caseNumber", msg => {
      this.road1[0].value = msg;
      this.road2[0].value = msg;
    })
  }
}
</script>

<style scoped>
.dialogEnv {
  width: 99%;
  height: 100%;
}

.formMsg {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
}

.el-form-item {
  width: 33%;
}

.el-form-item__content {
  width: calc(100% - 45%);
}

.el-input {
  width: 100%;
}

.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/data/dialogRoad.vue